import { h } from 'vue'

export default {
  name: "table-column-custom-render",
  props: {
    row: Object,
    column: Object,
    rowIndex: Number,
    columnIndex: Number,
    dataTableRef: Object,  //指向data-table组件实例
    renderFn: Function
  },
  render() {
    const params = {
      row: this.row,
      column: this.column,
      rowIndex: this.rowIndex,
      columnIndex: this.columnIndex,
      dataTableRef: this.dataTableRef,  //指向data-table组件实例
    }
    
    // 在Vue 2中，无法直接访问应用程序上下文，需要将组件作为参数传递
    // const components = this.$options.components

    return this.renderFn(h, params)
  }
}

// export default {
//   name: "table-column-custom-render",
//   functional: true,
//   props: {
//     row: Object,
//     column: Object,
//     render: Function
//   },
//   render(h, ctx) {
//     const params = {
//       row: ctx.props.row,
//       column: ctx.props.column,
//     }

//     return ctx.props.render(h, params)
//   }
// }
